
import React, { useRef, useEffect, useState } from 'react';
import './Popup.css';

function Popup(props) {
  const popupRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // 动画处理
  useEffect(() => {
    setTimeout(() => setIsVisible(true), 50);
  }, []);

  // 关闭处理
  const handleClose = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      setIsVisible(false);
      setTimeout(props.onClose, 300); // 等待动画完成
    }
  };

  return (
    <div className={`popup-overlay ${isVisible ? 'visible' : ''}`} onClick={handleClose}>
      <div className="popup-card" ref={popupRef}>
        <button className="close-btn" onClick={props.onClose}>
          &times;
        </button>
        <h2>{props.title}</h2>
        <div className="popup-content">
          <p>{props.message}</p>
          {props.children}
        </div>
      </div>
    </div>
  );
}


export default Popup;